import React from "react";
import Header from "./Header";
import ApplicantView from "../applicants/ApplicantView";

export default function LayoutApplicantView() {
  return (
    <>
      <Header />
      <ApplicantView />
    </>
  );
}
